import { Button } from "common/src/styles";
import processingIcon from "../../../assets/processing.svg";
import { ProgressStatus } from "../../../hooks/attestations/config";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import GenericModal from "../../common/GenericModal";
import SquidWidget from "../../round/ViewCartPage/SquidWidget";
import { useState } from "react";
import { NATIVE } from "common";

// Extracted ActionButton component
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ActionButton = _ref => {
  let {
    isConnected,
    status,
    handleSwitchChain,
    handleAttest,
    notEnoughFunds,
    isLoading
  } = _ref;
  const [openSwapModel, setOpenSwapModal] = useState(false);
  const swapParams = {
    fromChainId: "8453",
    toChainId: "42161",
    fromTokenAddress: NATIVE,
    toTokenAddress: NATIVE
  };
  const swapModalHandler = async flag => {
    setOpenSwapModal(flag);
  };
  if (!isConnected) {
    return /*#__PURE__*/_jsx(Button, {
      className: "bg-[#DE3714] text-white font-mono text-md w-full px-4 py-2 rounded-lg hover:shadow-md",
      children: /*#__PURE__*/_jsx(ConnectButton, {})
    });
  } else if (status === ProgressStatus.SWITCH_CHAIN) {
    return /*#__PURE__*/_jsx(Button, {
      onClick: handleSwitchChain,
      className: "bg-[#DE3714] text-white font-mono text-md w-full px-4 py-2 rounded-lg hover:shadow-md",
      children: "Switch Chain"
    });
  } else if (notEnoughFunds) {
    return /*#__PURE__*/_jsxs("div", {
      className: "w-full flex flex-col items-start gap-3",
      children: [/*#__PURE__*/_jsx("span", {
        className: "p-2 text-sm font-modern-era-medium",
        children: "Insufficient funds to complete the minting process. Please bridge or add funds to your wallet to proceed."
      }), /*#__PURE__*/_jsx(Button, {
        onClick: () => {
          swapModalHandler(true);
        },
        className: "bg-[#DE3714] text-white font-mono text-md w-full px-4 pb-2 rounded-lg hover:shadow-md",
        children: "Bridge Funds"
      }), /*#__PURE__*/_jsx(GenericModal, {
        isIframe: true,
        body: /*#__PURE__*/_jsx(SquidWidget, {
          ...swapParams
        }),
        isOpen: openSwapModel,
        setIsOpen: swapModalHandler,
        className: "z-40"
      })]
    });
  } else if (status === ProgressStatus.NOT_STARTED || status === ProgressStatus.IS_ERROR) {
    return /*#__PURE__*/_jsx(Button, {
      onClick: handleAttest,
      className: "bg-[#00433B] text-white font-mono text-md w-full px-4 py-2 rounded-lg hover:shadow-md",
      disabled: isLoading,
      children: isLoading ? "Loading..." : "Mint"
    });
  } else if (status === ProgressStatus.IN_PROGRESS) {
    return /*#__PURE__*/_jsxs(Button, {
      className: "bg-[#00433B] text-white w-full font-mono text-md px-4 py-2 rounded-lg flex items-center justify-center gap-2 hover:shadow-md",
      children: [/*#__PURE__*/_jsx("img", {
        src: processingIcon,
        alt: "Processing Icon",
        className: "w-5 h-5 animate-reverse-spin"
      }), /*#__PURE__*/_jsx("span", {
        children: "Processing"
      })]
    });
  } else {
    return null;
  }
};